import AlertLevel from "../../../models/alert";
import AlertModal from "../../Shared/AlertModal/AlertModal";
import { FormattedMessage } from "react-intl";
import ecgSentIcon from "../../../assets/ecgs/ecg_sent.svg";
import { ReactNode } from "react";

type EcrOnDemandSentInfoModalProps = {
  show?: boolean;
  onClose: () => void;
  showIcon?: boolean;
  iconSrc?: string;
  title?: ReactNode;
  message?: ReactNode;
};

const SuccessModal = ({
  show,
  onClose,
  title,
  message,
  showIcon = true,
  iconSrc = ecgSentIcon,
}: EcrOnDemandSentInfoModalProps) => (
  <AlertModal
    title={
      <>
        {showIcon ? (
          <div style={{ marginBottom: "15px" }}>
            <img src={iconSrc} alt="" />
          </div>
        ) : (
          ""
        )}
        {title}
      </>
    }
    show={show}
    onClose={onClose}
    level={AlertLevel.Info}
    okBtn={{
      text: <FormattedMessage id="ECG_DETAILS.OK" defaultMessage={`✓   OK`} />,
      onClick: onClose,
    }}
  >
    <p>
      {message} <br />
    </p>
  </AlertModal>
);

export default SuccessModal;
